import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import moment, { Moment } from 'moment';

export const dateTimeFuture = (): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
        const selectedDateTimeStr: string | null = control.value;

        if (!selectedDateTimeStr) {
            return null;
        }

        const selectedDateTime: Moment = moment(selectedDateTimeStr, moment.ISO_8601);
        const currentDate: Moment = moment();

        if (selectedDateTime.isAfter(currentDate)) { // Cambia isBefore por isAfter
            return { dateTimeFuture: true };
        }

        return null;
    };
};
